import * as React from "react";

export function HealthHeader(props: any) {
	if (!props.order.policyId)
		return (
			<div>
			
			</div>
		);
	
	return (
		<div>
			<p>{props?.order?.policyId}</p>
		</div>
	);
}
